import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';

const Container = ({ rendering, fields, params }) => {
  return (
    <div
      id="vds-main-content"
      className={`vds-page-container${
        params?.variant ? ` vds-page-container--${params.variant}` : ''
      }`}
      data-testid={`${fields.testid?.value}-container`}
    >
      <Placeholder name="main-content" rendering={rendering} />
    </div>
  );
};

export default Container;
